export default "/images/315e2dedb92fe3420a0141d37a55b6e8.avif";